import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import ShipmentChargesTable from "../../components/ShipmentCharges/ShipmentChargesTable";
import AddShipCharges from "../../components/ShipmentCharges/AddShipCharges";
import UpdateShipCharges from "../../components/ShipmentCharges/UpdateShipCharges";



const UpdateShipChargesPage = () => {
    return (
        <>
            {/* MasterLayout */}
            <MasterLayout>

                <Breadcrumb title="Update Shipment Charges"  subtitle={"Shipment Charges"} subUrl={"shipment-charges"}/>
                <UpdateShipCharges/>



            </MasterLayout>
        </>
    );
};

export default UpdateShipChargesPage;
